/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AptosAddressSummaryInfo } from './AptosAddressSummaryInfo';
import type { AptosCoinInfo } from './AptosCoinInfo';
import type { AptosFunctionSummaryInfo } from './AptosFunctionSummaryInfo';

export type AptosTrxScrollInfo = {
    VER: string;
    BHT: string;
    TRXTP: AptosTrxScrollInfo.TRXTP;
    AG: string;
    UT: number;
    ADDRSFROMINFO: AptosAddressSummaryInfo;
    ADDRSTOINFO: AptosAddressSummaryInfo;
    FUNCSINFO: AptosFunctionSummaryInfo;
    AMT: string;
    GF: string;
    COINLIST: Array<AptosCoinInfo>;
};

export namespace AptosTrxScrollInfo {

    export enum TRXTP {
        ALL = 'all',
        GENESIS_TRANSACTION = 'genesis_transaction',
        BLOCK_METADATA_TRANSACTION = 'block_metadata_transaction',
        USER_TRANSACTION = 'user_transaction',
        STATE_CHECKPOINT_TRANSACTION = 'state_checkpoint_transaction',
        VALIDATOR_TRANSACTION = 'validator_transaction',
        PENDING_TRANSACTION = 'pending_transaction',
        BLOCK_EPILOGUE_TRANSACTION = 'block_epilogue_transaction',
    }


}

